import { parseVimeoUrl } from 'client/components/vimeo-embed';

type Props = {
  url: string;
  caption?: string;
};

function getEmbedUrl(url: string): string | undefined {
  const vimeo = parseVimeoUrl(url);
  if (vimeo) {
    const hashParam = vimeo.hash ? `?h=${vimeo.hash}` : '';
    return `https://player.vimeo.com/video/${vimeo.id}${hashParam}`;
  }

  const ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]+)/);
  if (ytMatch) {
    return `https://www.youtube.com/embed/${ytMatch[1]}`;
  }

  const wistiaMatch = url.match(
    /(?:fast\.wistia\.(?:net|com)\/embed\/iframe\/|(?:.*\.)?wistia\.com\/medias\/)([a-zA-Z0-9]+)/,
  );
  if (wistiaMatch) {
    return `https://fast.wistia.net/embed/iframe/${wistiaMatch[1]}`;
  }

  return undefined;
}

export function VideoEmbed({ url, caption }: Props) {
  const embedUrl = getEmbedUrl(url);
  if (!embedUrl) {
    return undefined;
  }

  return (
    <div class="max-w-3xl mx-auto px-6 py-8">
      <div class="relative w-full" style="padding-top: 56.25%">
        <iframe
          src={embedUrl}
          class="absolute inset-0 w-full h-full rounded-xl shadow-lg"
          style="border: 0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </div>
      {caption && <p class="text-center text-gray-500 text-sm mt-3">{caption}</p>}
    </div>
  );
}
